<template>
  <div class="d-flex align-center justify-center flex-column">
    <v-icon size="32" color="blue" class="mb-3"
      >mdi-check-circle-outline</v-icon
    >
    <p class="text-center subtitle-2 blue-grey--text text--darken-3 mb-8">
      {{ $t('excel.success_message', { totalRows: totalRows }) }}
    </p>
    <Button
      color="primary"
      :text="$t('common.new_import')"
      @click="$emit('startOver')"
    />
  </div>
</template>

<script>
import Button from '@/ui/shared/components/Button.vue'

export default {
  name: 'Finish',

  components: { Button },

  props: {
    totalRows: Number,
  },
}
</script>
